const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the delete assignment directive
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('deleteAssignment', ['Assignments', function (Assignments) {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      assignment: '=',
      onDelete: '&'
    },
    template: require('../../templates/directives/delete-assignment.html'),
    controller: ['$scope', function ($scope) {
      var self = this;

      self.cancel = function() {
        $scope.assignment = null;
      };

      self.delete = function() {
        self.loading = true;
        Assignments.remove({subresource: $scope.assignment._id}).$promise
        .then(function(results) {
          self.loading = false;
          setTimeout(function() {
            $scope.onDelete();
          }, 1);
        }).catch(function(error) {
          self.loading = false;
          console.log('error: ', error)
        });
      };

      self.init = function() {
        if (!$scope.assignment || !$scope.assignment._id) {
          $scope.assignment = null;
          return;
        }
        var contents = ['article', 'media', 'track', 'quiz', 'scorm', 'imported_content', 'assessment'];
        var content = {};
        for (var i = 0; i < contents.length; i++) {
          if ($scope.assignment[contents[i]]) {
            content = $scope.assignment[contents[i]];
          }
        }
        self.contentTitle = content.name || content.title || '';
      };

      self.init();

      $scope.$watch('assignment', function(newVal, oldVal) {
        if (newVal) {
          self.init();
        }
      });

    }],
    controllerAs: 'cancelAssignment'
  };
}]);